import { Feature } from '@tencent/workbench';
import BaseGridFeature from '@framework/workbench/common/feature/base-grid-feature';
import { config } from '@framework/workbench/ui/border-style/config';
import { ActionType } from '@editor/src/js/constants/common-action-type';
import GridMenu from '@com/tool-bar/menu/grid-menu';
import { INPUT_PROPS_CALLBACK_KEY } from '../../../constants';

@Feature()
export class TableBorderFeature extends BaseGridFeature {
    id = config.id;
    config = config;
    public gridMenuInstance;
    public constructor() {
        super();
        this.addInitPropsCallback(INPUT_PROPS_CALLBACK_KEY.TABLE_BORDER);
    }

    public initPropsCallback = () => {
        const value = this.tableBorderItem;
        this.gridMenuInstance = new GridMenu({
            id: ActionType.BORDERSTYLE,
            menuValue: value,
            data: config.dropdown.data,
            onMenuClick: this.handleMenuClick,
            selectionService: this.getSelectionService(),
        });
    };

    public get tableBorderItem() {
        return this.getItemValue();
    }
}
